module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-proficiency.171bfeba.svg";